import { Pipe, PipeTransform } from '@angular/core';
import { MemberAccount } from '../../../models/transactions/member-account';
import { StatusPill } from '../../../models/shared/status-pill';

@Pipe({
  name: 'accountStatusPill',
  standalone: true
})
export class AccountStatusPillPipe implements PipeTransform {
  transform(account: MemberAccount): StatusPill {
    return account.getStatusPill();
  }
}
